import {allAnimationsFinished, requestAnimationFrame} from '@acng/frontend-bounty';
import {remove as removeElement} from '@acng/frontend-bounty/dom/move.js';
import {isElement} from '@acng/frontend-bounty/dom/check.js';
import {add, remove} from '@acng/frontend-bounty/style/element.js';
import {createPromise} from '@acng/frontend-bounty/std/control.js';

import {STYLE_ENTER, STYLE_LEAVE} from '../style/flags.js';

/**
 * @param {Element} element
 */
export const enter = (element) => animate(element, STYLE_ENTER);

/**
 * @param {Element} element
 *
 * @returns {Promise<void>}
 */
export const leave = async (element) => {
  await animate(element, STYLE_LEAVE);

  removeElement(element);
};

/**
 * @param {ChildNode} childNode
 */
export const enterNode = (childNode) => isElement(childNode) && enter(childNode);

/**
 * @param {ChildNode} childNode
 */
export const leaveNode = (childNode) => (isElement(childNode) ? leave(childNode) : removeElement(childNode));

/**
 * @param {Element} element
 * @param {string} name
 * @param {boolean} [keep]
 *
 * @returns {Promise<void>}
 */
export const animate = (element, name, keep) =>
  createPromise(
    /**
     * The `setTimout` is required for transitions to start if the element has
     * just been inserted.
     */
    (resolve) => {
      add(element, name);

      requestAnimationFrame(async () => {
        const ACTIVE = `${name}-active`;

        add(element, ACTIVE);
        // TODO subtree might contain infinite animations, so provide the subtree option via attribute or class
        await allAnimationsFinished(element);

        remove(element, ACTIVE);

        if (!keep) {
          remove(element, name);
        }
        resolve();
      });
    },
  );
